export default [
    {
        productId: 1,
        description: "Lamellhus med 2&ndash;6 våningar, hälften tvåor och hälften treor.<br />Alternativt 3&ndash;8 våningar med lika fördelning av ettor, tvåor och treor."
    },
    {
        productId: 2,
        description: "Tillgänglighetsanpassat med gemensamhetslokal i bottenvåningen. Lämpligt för trygghetsboende. Lamellhus om 3&ndash;6 våningar med lika fördelning av ettor, tvåor och treor."
    },
    {
        productId: 3,
        description: "Lamellhus om 3&ndash;6 våningar med flexibel planlösning. Kan användas för att bygga öppna eller slutna kvarter i bullriga miljöer. En tyst sida och källare."
    },
    {
        productId: 4,
        description: "Lamellhus om 3&ndash;6 våningar med flexibel planlösning. Tyst sida. Kan byggas i bullriga miljöer, exempelvis nära kollektivtrafik."
    },
    {
        productId: 5,
        description: "Punkthus om 5&ndash;8 våningar med flera olika planlösningar att välja bland, från många små lägenheter till en blandning av små och större."
    },
    {
        productId: 6,
        description: "Förstahandsval om du har projekt där alla hus är 3&ndash;6 våningsplan."
    },
    {
        productId: 7,
        description: "Förstahandsval för alla projekt."
    },
    {
        productId: 8,
        description: "Välj detta om JSB tackar nej."
    },
    {
        productId: 10,
        description: "Förstahandsval för alla projekt."
    },
    {
        productId: 11,
        description: "Välj detta om Götenehus tackar nej."
    },
    {
        productId: 12,
        description: "Välj detta om både Götenehus och Derome tackar nej."
    },
]



// WEBPACK FOOTER //
// ./assets/vue/houseModel/helpers/referenceHouseProducts.js